import api from "../../../services/api";

// Ações manuais da Central. Diferente do resto da Central, que só lê, estas
// rotas ESCREVEM (ERP ou Zabbix) — por isso as telas confirmam com o
// operador antes de chamar.
//
// A abertura de atendimento (zona morta) não está aqui: reusa o
// ModalNewTicket do sistema, que já fala com /interno/create/ticket.

// OS faltante -> cria a OS vinculada ao atendimento já existente.
export async function criarOsDoAlerta({
	atendimentoId,
	servicoId,
	dataOs,
	tipoAgendamento,
	erpId,
	signal,
}) {
	const { data } = await api.post(
		"/interno/centralAlertas/acoes/criarOs",
		// erpId: ERP do incidente (o escolhido no painel).
		{ atendimentoId, servicoId, dataOs, tipoAgendamento, erpId: erpId || undefined },
		{ signal },
	);
	return data;
}

// Marco "Reconhecimento" da linha do tempo -> reconhece no Zabbix (a ÚNICA
// escrita no Zabbix do sistema) TODOS os eventos do incidente (`eventIds` —
// cluster inteiro, primário primeiro) e, opcionalmente, cria a regra de
// reconhecimento automático por trigger/período (mesma trigger, mesmo
// equipamento, enquanto o período não expira).
export async function reconhecerAlerta({
	eventIds,
	hostId,
	mensagem,
	reconhecerProximos,
	periodoMinutos,
	signal,
}) {
	const { data } = await api.post(
		"/interno/centralAlertas/acoes/reconhecerAlerta",
		{ eventIds, hostId, mensagem, reconhecerProximos, periodoMinutos },
		{ signal },
	);
	return data;
}
